module.exports = __webpack_public_path__ + "officialStatic/img/goerLogo.03452c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/goerLogo.png
// module id = avea
// module chunks = 0